// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { FC, useState } from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
import { MenuItemConfig, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';

interface LanguageSelectorMobileProps {
  languageMenuItems: Array<MenuItemConfig>;
  iconName: string;
}

const LanguageSelectorMobile: FC<LanguageSelectorMobileProps> = ({ languageMenuItems, iconName }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <UitkMenu isOpen={isOpen} onTriggerClick={() => setIsOpen((prevState) => !prevState)}>
      <UitkMenuTrigger>
        <UitkTertiaryButton
          size={UitkButtonSize.LARGE}
          name="language-selection"
          data-testid="language-selection-button"
        >
          <UitkIcon name={iconName} size={UitkIconSize.LARGE} theme="default" />
        </UitkTertiaryButton>
      </UitkMenuTrigger>
      <UitkMenuContainer className="language-selection-menu">
        <UitkMenuList items={languageMenuItems} />
      </UitkMenuContainer>
    </UitkMenu>
  );
};

export default LanguageSelectorMobile;
